exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".contacts {\r\n}\r\n\r\n/* Инструменты */\r\n\r\n.contacts__tools {\r\n    margin-bottom: 20px;\r\n    padding-bottom: 5px;\r\n\r\n    border-bottom: 1px solid #ccc;\r\n}\r\n\r\n/* Контакты */\r\n\r\n.contacts__list {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-flow: row wrap;\r\n            flex-flow: row wrap;\r\n}\r\n.contacts__item {\r\n    width: 30%;\r\n    margin-right: 5%;\r\n    margin-bottom: 20px;\r\n}\r\n.contacts__item:nth-child(3n + 3) {\r\n    margin-right: 0;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/mailbox/contacts/contacts.component.css
// module id = 593
// module chunks = 1